/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_Seller_AgreementInputs */

const en_doc_type_seller_agreement = /** @type {(inputs: Doc_Type_Seller_AgreementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seller Agreement`)
};

const id_doc_type_seller_agreement = /** @type {(inputs: Doc_Type_Seller_AgreementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perjanjian Penjual`)
};

/** @type {(inputs: Doc_Type_Seller_AgreementInputs) => LocalizedString} */
const es_doc_type_seller_agreement = en_doc_type_seller_agreement;

/** @type {(inputs: Doc_Type_Seller_AgreementInputs) => LocalizedString} */
const fr_doc_type_seller_agreement = en_doc_type_seller_agreement;

/** @type {(inputs: Doc_Type_Seller_AgreementInputs) => LocalizedString} */
const de_doc_type_seller_agreement = en_doc_type_seller_agreement;

/** @type {(inputs: Doc_Type_Seller_AgreementInputs) => LocalizedString} */
const ja_doc_type_seller_agreement = en_doc_type_seller_agreement;

/** @type {(inputs: Doc_Type_Seller_AgreementInputs) => LocalizedString} */
const zh_doc_type_seller_agreement = en_doc_type_seller_agreement;

/** @type {(inputs: Doc_Type_Seller_AgreementInputs) => LocalizedString} */
const ar_doc_type_seller_agreement = en_doc_type_seller_agreement;

/** @type {(inputs: Doc_Type_Seller_AgreementInputs) => LocalizedString} */
const it_doc_type_seller_agreement = en_doc_type_seller_agreement;

/** @type {(inputs: Doc_Type_Seller_AgreementInputs) => LocalizedString} */
const ru_doc_type_seller_agreement = en_doc_type_seller_agreement;

/** @type {(inputs: Doc_Type_Seller_AgreementInputs) => LocalizedString} */
const pt_doc_type_seller_agreement = en_doc_type_seller_agreement;

/** @type {(inputs: Doc_Type_Seller_AgreementInputs) => LocalizedString} */
const ko_doc_type_seller_agreement = en_doc_type_seller_agreement;

/**
* | output |
* | --- |
* | "Seller Agreement" |
*
* @param {Doc_Type_Seller_AgreementInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_seller_agreement = /** @type {((inputs?: Doc_Type_Seller_AgreementInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_Seller_AgreementInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_seller_agreement(inputs)
	if (locale === "es") return es_doc_type_seller_agreement(inputs)
	if (locale === "fr") return fr_doc_type_seller_agreement(inputs)
	if (locale === "de") return de_doc_type_seller_agreement(inputs)
	if (locale === "ja") return ja_doc_type_seller_agreement(inputs)
	if (locale === "zh") return zh_doc_type_seller_agreement(inputs)
	if (locale === "ar") return ar_doc_type_seller_agreement(inputs)
	if (locale === "id") return id_doc_type_seller_agreement(inputs)
	if (locale === "it") return it_doc_type_seller_agreement(inputs)
	if (locale === "ru") return ru_doc_type_seller_agreement(inputs)
	if (locale === "pt") return pt_doc_type_seller_agreement(inputs)
	return ko_doc_type_seller_agreement(inputs)
});